import { useEffect, useRef, useState } from 'react';
import LoadingCircle from '~components/Loading';
import useCompanyFinancialChartData, {
  FinancialChartData,
} from '~hooks/query/company/useCompanyFinancialChart';

import ChartContents from './ChartContents';
import { TEMPLATE_CHART_DATA } from './constants';
import * as S from './style';

interface Props {
  companyId: string;
}

export default function FinancialChart({ companyId }: Props) {
  const [chartData, setChartData] = useState<FinancialChartData[]>();
  const [isEmpty, setIsEmpty] = useState<boolean>();
  const { data, status } = useCompanyFinancialChartData(companyId);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (data) {
      const chartData = data.financialReport[data.source] ?? [];
      const mergedChartData = TEMPLATE_CHART_DATA.map((item) => {
        const obj = chartData.find((chartObj) => chartObj.year === item.year);

        if (!obj) {
          return item;
        }

        return obj;
      });

      const _isEmpty = mergedChartData.every((data) => data.salesAmount === null);

      setChartData(mergedChartData);
      setIsEmpty(_isEmpty);
    }
  }, [data]);

  return (
    <S.Wrapper ref={wrapperRef}>
      {status === 'success' ? (
        <ChartContents data={chartData as FinancialChartData[]} isEmpty={isEmpty} />
      ) : (
        <LoadingCircle />
      )}
    </S.Wrapper>
  );
}
